<template>
    <div id="header_options_component"
         class="header-options-component">
        <div class="header-options-inner">
            <ul class="header-options-list">
                <li>
                    <header-options-signout></header-options-signout>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import HeaderOptionsSignout from './options/HeaderOptionsSignout.vue'

    export default {
        components: { HeaderOptionsSignout }
    }
</script>

<style lang="scss">
    @import "../../../../../assets/scss/_colors.scss";

    .header-options-component{
        display: inline-block;
        vertical-align: middle;
        margin-right: 4px;
    }

    .header-options-list{
        padding: 0;
        margin: 0;
        list-style: none;
        text-align: right;
        word-spacing: 10px;

        >li{
            display: inline-block;
            vertical-align: middle;
            word-spacing: normal;

            .header-options-icon{
                a{
                    display: block;
                    line-height: 46px;
                    color: $base2;
                    font-size: 36px;
                    transition: 200ms color linear;

                    &:hover,
                    &:focus{
                        color: darken($base2, 15%);
                     }
                }

                &.header-options-icon-color--gray{
                    a{
                        color: $gray;

                        &:hover,
                        &:focus{
                             color: darken($gray, 15%);
                         }
                    }
                 }
            }
        }
    }

    @media(max-width: 991px){
        .header-options-list{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            height: 70px;

            >li{
                margin-left: 29px;
            }
        }
    }

    @media(max-width: 359px){
        .header-options-list{
            >li{
                margin-left: 15px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/header/middlebar/HeaderOptions.vue